const CrossIcon = (props) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.6758 1.47888L1.47266 19.682"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6758 19.682L1.47266 1.47888"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CrossIcon
